import { render } from "./Cred.vue?vue&type=template&id=8e37cfde&scoped=true"
import script from "./Cred.vue?vue&type=script&lang=js"
export * from "./Cred.vue?vue&type=script&lang=js"

import "./Cred.vue?vue&type=style&index=0&id=8e37cfde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e37cfde"]])

export default __exports__